import React from 'react';
import PropTypes from 'prop-types';
import { merge as _merge } from 'lodash';

const assignIfNotNull = (schemaData, propKey, prop) => {
  if (!prop) {
    return schemaData;
  }

  return _merge(schemaData, { [propKey]: prop });
};

const formatOutput = (props) => {
  let schemaData = { '@context': `http://schema.org` };
  schemaData = assignIfNotNull(schemaData, `@graph`, props.graph);
  schemaData = assignIfNotNull(schemaData, `@id`, props.id);

  return JSON.stringify(schemaData);
};

const StructuredData = (props) => (
  <script
    dangerouslySetInnerHTML={{__html: formatOutput(props)}}
    type="application/ld+json"
  />
);

StructuredData.propTypes = {
  graph: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  id: PropTypes.string,
};

export default StructuredData;
